/**
 * Generated by orval v7.11.2 🍺
 * Do not edit manually.
 * Supervizor APIs
 * Here is the list of the API endpoints of Supervizor. Click on one to display its implementation. 

Some APIs are protected and require a Bearer token in the Authorization header
 * OpenAPI spec version: 1.0
 */
import {
  useQuery,
  useSuspenseQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult
} from '@tanstack/react-query';

import type {
  GetAnalysisReportByIdResponseDto
} from '.././model';

import { customAxiosInstance } from '../../axios/axiosInstance';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



/**
 * @summary Get an analysis report
 */
export const getAnalysisReportById = (
    id: string,
 options?: SecondParameter<typeof customAxiosInstance>,signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<GetAnalysisReportByIdResponseDto>(
      {url: `/analysis-reports/${id}`, method: 'GET', signal
    },
      options);
    }
  

export const getGetAnalysisReportByIdQueryKey = (id?: string,) => {
    return [`/analysis-reports/${id}`] as const;
    }

    
export const getGetAnalysisReportByIdQueryOptions = <TData = Awaited<ReturnType<typeof getAnalysisReportById>>, TError = null | null | null>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAnalysisReportById>>, TError, TData>>, request?: SecondParameter<typeof customAxiosInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAnalysisReportByIdQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAnalysisReportById>>> = ({ signal }) => getAnalysisReportById(id, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAnalysisReportById>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAnalysisReportByIdQueryResult = NonNullable<Awaited<ReturnType<typeof getAnalysisReportById>>>
export type GetAnalysisReportByIdQueryError = null | null | null


export function useGetAnalysisReportById<TData = Awaited<ReturnType<typeof getAnalysisReportById>>, TError = null | null | null>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAnalysisReportById>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAnalysisReportById>>,
          TError,
          Awaited<ReturnType<typeof getAnalysisReportById>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxiosInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAnalysisReportById<TData = Awaited<ReturnType<typeof getAnalysisReportById>>, TError = null | null | null>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAnalysisReportById>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAnalysisReportById>>,
          TError,
          Awaited<ReturnType<typeof getAnalysisReportById>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxiosInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAnalysisReportById<TData = Awaited<ReturnType<typeof getAnalysisReportById>>, TError = null | null | null>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAnalysisReportById>>, TError, TData>>, request?: SecondParameter<typeof customAxiosInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get an analysis report
 */

export function useGetAnalysisReportById<TData = Awaited<ReturnType<typeof getAnalysisReportById>>, TError = null | null | null>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAnalysisReportById>>, TError, TData>>, request?: SecondParameter<typeof customAxiosInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAnalysisReportByIdQueryOptions(id,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetAnalysisReportByIdSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getAnalysisReportById>>, TError = null | null | null>(id: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAnalysisReportById>>, TError, TData>>, request?: SecondParameter<typeof customAxiosInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAnalysisReportByIdQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAnalysisReportById>>> = ({ signal }) => getAnalysisReportById(id, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAnalysisReportById>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAnalysisReportByIdSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getAnalysisReportById>>>
export type GetAnalysisReportByIdSuspenseQueryError = null | null | null


export function useGetAnalysisReportByIdSuspense<TData = Awaited<ReturnType<typeof getAnalysisReportById>>, TError = null | null | null>(
 id: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAnalysisReportById>>, TError, TData>>, request?: SecondParameter<typeof customAxiosInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAnalysisReportByIdSuspense<TData = Awaited<ReturnType<typeof getAnalysisReportById>>, TError = null | null | null>(
 id: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAnalysisReportById>>, TError, TData>>, request?: SecondParameter<typeof customAxiosInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAnalysisReportByIdSuspense<TData = Awaited<ReturnType<typeof getAnalysisReportById>>, TError = null | null | null>(
 id: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAnalysisReportById>>, TError, TData>>, request?: SecondParameter<typeof customAxiosInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get an analysis report
 */

export function useGetAnalysisReportByIdSuspense<TData = Awaited<ReturnType<typeof getAnalysisReportById>>, TError = null | null | null>(
 id: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAnalysisReportById>>, TError, TData>>, request?: SecondParameter<typeof customAxiosInstance>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAnalysisReportByIdSuspenseQueryOptions(id,options)

  const query = useSuspenseQuery(queryOptions , queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



